<template>
    <div class="service-listing">
        <div class="row">
            <div style="padding-left: 1px;" class="col-sm-3 col-lg-3 tablet-full-width">
                <div class="filter"></div>
                <div class="filter-component">
                    <filterservice :apiResponse="info"
                                   :FilterByDate="FilterByDate"
                                   :filter="getData"
                                   @depArr="depArr = $event"
                                   @categoryArr="cateArr = $event"
                                   @sectorArr="sectorArr = $event"
                                   @subArr="subArr = $event"
                                   @healthArr="healthArr = $event"
                                   @funcArr="funcArr = $event"
                                   @tarckApplyFilter="tarckApplyFilter = true"
                                   :PageType="PageType"
                                   :rules="rules"
                                   :CategoriesOfRules="CategoriesOfRules"
                                   v-if="info && (services || announcement || rules)"
                                   :sectorLab="SectorLabel"
                                   :categoryLab="CategoryLabel"
                                   :productLab="ProductsLabel"
                                   :functionsLab="FunctionsLabel"
                                   :searchLab="SearchLabel"
                                   @datestart="datestart = $event"
                                   @dateend="dateend = $event"
                                   @resetDate="resetDate = $event"
                                   :ClearDateFilter="ClearDateFilter"
                                   :Apply="Apply"
                                   :Reset="Reset"
                                   :From="From"
                                   :key="reinitFilter"
                                   :To="To"
                                   :Required="Required"
                                   @ruleArr="ruleArr = $event"
                                   :BackBtn="backBtn" />
                    <div class="generic-loader filter-loader" v-if="apiCallLoader">
                        <img src="../../../Assets/Images/spinner.svg" />
                    </div>
                </div>

            </div>
            <div class="col-sm-9 col-lg-9 tablet-full-width">
                <div class="accordion-wrapper">
                    <servicesearch @searchKeyword="(searchWord = $event), (searchClicked = true)"
                                   :searchFilter="getData"
                                   :searchLab="SearchLabel"
                                   :searchPlaceHolder="SearchPlaceHolder"
                                   :key="reinitFilter" />
                    <h3 v-if="noDataMsg" class="empty-msg">
                        {{ NoResultMessage }}
                    </h3>
                    <div class="generic-loader " v-show="isAjaxLoading">
                        <img src="../../../Assets/Images/spinner.svg" />
                    </div>
                    <div class="accordion" id="accordionExample">
                        <div v-if="filteredData.length != 0">
                            <rules-regulations :rulesRegulations="filteredData"
                                               :download="Download"></rules-regulations>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script>
    import axios from "axios";
    import servicesearch from "../GenericPageComponent/ServiceSearch/ServiceSearch.vue";
    import filterservice from "../GenericPageComponent/Filter/FilterService.vue";
    import rulesRegulations from "../GenericListingComponent/RulesAndRegulationsBlock/RulesAndRegulations.vue";

    // import Vue from "vue";
    // import servicesearch from "../ServiceSearch/ServiceSearch.vue";
    // import filterservice from "../Filter/FilterService.vue";
    // import DatePicker from "v-calendar/lib/components/date-picker.umd";
    // Vue.component("v-date-picker", DatePicker);

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let language = window.CurrentLanguage.CurrentLanguage;
    export default {
        components: {
            filterservice,
            servicesearch,
            rulesRegulations,
        },
        data() {
            return {
                announcement: false,
                rules: true,
                services: false,
                reinitFilter: 0,
                searchClicked: false,
                tarckApplyFilter: false,
                infoData: [],
                info: [],
                ruleArr: [],
                isAjaxLoading: true,
                filteredData: [],
                noDataMsg: false,
                pageNumber: 1,
                loadOnScrollTriger: true,
                apiCallLoader: false
            };
        },
        props: {
            backBtn: {
                type: String,
            },
            PageType: {
                type: String,
            },
            checkSector: {
                type: Boolean,
            },
            Required: {
                type: String,
            },
            Download: {
                type: String,
            },
            To: {
                type: String,
            },
            From: {
                type: String,
            },
            ClearDateFilter: {
                type: String,
            },
            FilterByDate: {
                type: String,
            },
            CategoriesOfRules: {
                type: String,
            },
            checkCateg: {
                type: String,
            },
            CategoryLabel: {
                type: String,
            },
            SectorLabel: {
                type: String,
            },
            FunctionsLabel: {
                type: String,
            },
            SearchPlaceHolder: {
                type: String,
            },
            ProductsLabel: {
                type: String,
            },
            SearchLabel: {
                type: String,
            },
            NoResultMessage: {
                type: String,
            },
            Apply: {
                type: String,
            },
            Reset: {
                type: String,
            },
        },
        methods: {
            getData() {

                this.noDataMsg = false;
                this.isAjaxLoading = true;
                this.infoData = [];

                if (this.searchWord || this.slideClicked || this.tarckApplyFilter) {
                    this.pageNumber = 1;
                    this.filteredData = [];
                }

                if (!this.loadOnScrollTriger) {
                    this.filteredData = [];
                }

                if (this.tarckApplyFilter) {
                    if (window.innerWidth > 1025) {
                        this.apiCallLoader = true;
                    }
                }
                this.tarckApplyFilter = false;

                let body = {
                    PageType: "rulesAndRegulations",
                    SelectedItemId: "", //item id of slider
                    Text: this.searchWord,
                    PageNumber: this.pageNumber,
                    DateFrom: this.datestart, //js Date
                    DateTo: this.dateend,
                    Categories: this.ruleArr,
                    HealthProducts: this.healthArr,
                    Functions: this.funcArr,
                    SubCategories: this.subArr,
                    Departments: this.depArr,
                    Sectors: this.sectorArr,
                };

                axios
                    .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, body)
                    .then((response) => {
                        this.apiCallLoader = false;
                        this.searchClicked = false;
                        this.infoData = response.data;
                        this.isAjaxLoading = false;
                        if (this.infoData.length != 0) {
                            this.slice();
                        } else {
                            if (this.filteredData.length != 0) {
                                this.noDataMsg = false;
                            } else {
                                this.noDataMsg = true;
                            }
                        }
                    });
            },
            getFilterData() {
                this.isAjaxLoading = true;
                this.noDataMsg = false;
                axios
                    .post(`${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?culture=${language}`)
                    .then((response) => {
                        this.info = response.data;
                        if (this.info.Sectors != null) {
                            for (let item of this.info.Sectors) {
                                this.$set(item, "checked", false);
                                item.Department = item.Department.map((str, index) => ({
                                    value: str,
                                    id: index + 1,
                                    checked: false,
                                }));
                            }
                        }
                        // if (this.info.HealthProducts != null) {
                        //   for (let item of this.info.HealthProducts) {
                        //     this.$set(item, "checked", false);
                        //   }
                        // }
                        // if (this.info.Functions != null) {
                        //   for (let item of this.info.Functions) {
                        //     this.$set(item, "checked", false);
                        //   }
                        // }
                        // if (this.info.CategoriesForRules != null) {
                        //   for (let item of this.info.CategoriesForRules) {
                        //     this.$set(item, "checked", false);
                        //   }
                        // }
                        this.addChecked(this.info.HealthProducts);
                        this.addChecked(this.info.CategoriesForRules);
                        this.addChecked(this.info.Functions);
                    });
            },

            slice() {
                this.filteredData = this.filteredData.concat(this.infoData);
            },
            checkTrigger() {

                const options = {
                    threshold: 0.1,
                };
                const checker = document.querySelector(".footer");
                const infiniteScroll = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (this.filteredData.length != 0) {
                                this.isAjaxLoading = true;

                                setTimeout(() => {
                                    if (window.innerWidth > 1025) {
                                        this.apiCallLoader = true;
                                    }
                                    // this.slice();
                                    this.pageNumber++;
                                    this.getData();
                                    this.isAjaxLoading = false;
                                }, 500);
                            }
                        }
                    });
                };

                const observer = new IntersectionObserver(infiniteScroll, options);
                observer.observe(checker);

            },
            addChecked(x) {
                if (x != null) {
                    for (let item of x) {
                        this.$set(item, "checked", false);
                    }
                }
            },
        },
        mounted() {
            this.getData();
            this.getFilterData();
            this.checkTrigger();

            document.querySelector(".register-page-form__loader").style.display =
                "none";
        },
    };
</script>
